module.exports = __webpack_public_path__ + "img/decorator-crowd.bc5c1b93.png";